import { render, staticRenderFns } from "./PropertyStatusButton.vue?vue&type=template&id=459ca764"
import script from "./PropertyStatusButton.vue?vue&type=script&lang=js"
export * from "./PropertyStatusButton.vue?vue&type=script&lang=js"
import style0 from "./PropertyStatusButton.vue?vue&type=style&index=0&id=459ca764&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports